module.exports = __webpack_public_path__ + "static/img/model3-1.5850da13.jpg";